import { AppPage } from 'common/Layout';
import { Buildings } from 'features/buildings';
import { homeBreadcrumbItem } from 'shared/UI/UIKit/Breadcrumbs';

const breadcrumbs = [
  homeBreadcrumbItem,
  {
    title: 'Здания',
    url: '',
  },
];

export const BuildingsPage = () => {
  return (
    <AppPage
      breadcrumbs={{
        items: breadcrumbs,
      }}
      documentTitle="Здания"
    >
      <Buildings />
    </AppPage>
  );
};
